import React, { useState, useEffect } from 'react';
// import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios'
import './styles/App.css'
import Categories from './components/Categories';
import { useDispatch, useSelector } from 'react-redux';
import FormWelcome from './components/FormWelcome';
import FormDefault from './components/FormDefault';
import CatFormUpdate from './components/CatFormUpdate';
import ProdFormAdd from './components/ProdFormAdd';
import ProdFormUpdate from './components/ProdFormUpdate';
import Modal from './components/UI/Modal/Modal';
import { useDeletePics } from './hooks/useDeletePics';
import { useToken } from './hooks/useToken';
import CatFormAdd from './components/CatFormAdd';
// import NotifyList from './components/NotifyList';
import NotifyList2 from './components/NotifyList2';
import { useNotify } from './hooks/useNotify';
import { define, tokenLifeTimeInfo, welcNotifyDuration } from './data/globals'
import MyCounter from './components/MyCounter';
// import { define, tokenLifeTimeInfo, defNotifyDuration, welcNotifyDuration } from './data/globals'
// import MyEditor from './components/UI/MyEditor/MyEditor';

function App() {
  const authStatus = useSelector(state => state.authStatus)
  const freeze = useSelector(state => state.freeze)
  const action = useSelector(state => state.action)
  const newCatStore = useSelector(state => state.newCat)
  const updCatStore = useSelector(state => state.updCat)
  const newProdStore = useSelector(state => state.newProd)
  const updProdStore = useSelector(state => state.updProd)
  const dispath = useDispatch()

  const { pushNotify } = useNotify()
  // Хук возвращает 3 функции
  const { delPicsToDelete, deleteNewPics, getBackFiles } = useDeletePics()
  // Хук для работы с токеном
  const { authMsg, createToken, checkPermissions } = useToken()
  const [ isProdsLoading, setIsProdsLoading ] = useState(false)
  const [ isCatsLoading, setIsCatsLoading ] = useState(false)
  const [ categories, setCategories ] = useState([])
  const [ products, setProducts ] = useState([])
  const [ awayModal, setAwayModal ] = useState(false)
  // const [ notifyList, setNotifyList ] = useState([])

// // ~~~~~~~~ Уведомления ~~~~~~~~
// // Важно! При использовании setTimeout фильтруем notifyRef.current, а не notifyList. Поскольку при добавлении элементов в массив notifyList и запуске удаления через setTimeout, состояение notifyList не изменится к моменту запуска delNotify по таймеру. В такой ситуации используем useRef (см. 2 строки ниже) и фильтруем notifyRef.current с актуальными данными
// const notifyRef = useRef(notifyList);
// notifyRef.current = notifyList;

// // Удаление уведомления
// function delNotify(id) {
//   setNotifyList( notifyRef.current.filter(item => item.id !== id) )
// }

// // Добавление уведомления
// function pushNotify(
//   notifyText = "Default Notification Text", // текст уведомления (можно html)
//   notifyClass = "notifyBlue", // цвета (стиль) уведомления
//   notifyDuration = defNotifyDuration // продолжительность показа уведомления (в мс)
// ){
//   let id = Date.now() // генерация уникального id
//   // 1. Добавляем уведомление в массив
//   let newNotify = { id: id, notifyText: notifyText, class: notifyClass }
//   setNotifyList([newNotify, ...notifyList])
//   // Анимация появления и исчезновения уведомлений
//   // При клике закрыть уведомление delNotify(id) - удаляем
//   // 2. Удаляем через некоторое время
//   setTimeout(()=>{
//     delNotify(id)
//   }, notifyDuration)
// }
// // ~~~~~~~~ ~~~~~~~~~~ ~~~~~~~~

// ~~~~~~~~~~~~~~~~~~~~~~~~~
  // Пользователь подтвердил, что хочет продолжить без сохранения
  function awayConfirmed() {
    setAwayModal(false)
    if(action === 'addP'){
      // Удаление (с диска сервера) несохраненных в БД файлов
      deleteNewPics()
    } else {
      // Удаление (с диска сервера) несохраненных в БД файлов
      deleteNewPics()
      resetUpdForm()
    }
    
    // Отключение заморозки действий
    dispath({ type: 'SetFreeze', value: false})
    pushNotify("Внесенные изменения отменены")
  }
// ~~~~~~~~~~~~~~~~~~~~~~~~~

  // Вернуть поля формы к значениям по умолчанию
  function resetUpdForm() {
      // Возврат элементов из picsToDelete в стор picsInDB
      getBackFiles()// this.$refs.updForm.$refs.uplModule.getBackFiles()

  }
  // Определение нового id (максимальный id + 1)
  async function getNewCategoryId(){
    try {
      // setIsCatsLoading(true)
      const response = await axios.get( define.pathToAPI + '/categories/getNewId.php')

      if(response.data.newId) {
        return response.data.newId
      } else {
        console.log('Функция getNewId не получила id (от getNewId.php)\n', response);
        return
      }
    } catch (e) {
      console.log(e + '\nОшибка при определении нового id для товара')
      return
    }
  }
  // Определение нового id (максимальный id + 1)
  async function getNewId(){
    try {
      // setIsCatsLoading(true)
      const response = await axios.get( define.pathToAPI + '/products/getNewId.php')

      if(response.data.newId) {
        return response.data.newId
      } else {
        console.log('Функция getNewId не получила id (от getNewId.php)\n', response);
        return
      }
    } catch (e) {
      console.log(e + '\nОшибка при определении нового id для товара')
      return
    }
  }
  // нажато "Добавить товар"
  async function selectAddCategory() {
    // сохранение id для нового (добавляемого) товара
    let newId = await getNewCategoryId()
    if(newId) dispath({ type: 'SetNewCat', id: newId })
  }
  // нажато "Добавить товар"
  async function selectAddProd(e, categoryId, categoryName) {
    e.stopPropagation()

    dispath({ type: 'SetUpdCatId', id: categoryId })
    getProducts(categoryId)

    // console.log('Добавление товара...\nСделать блокировку (типа если пользователь случайно кликнет на какой-то товар, то спросить, точно ли он хочет покинуть страницу добавления нового товара без сохранения изменений)')
    // Очищаем массив в сторе
    dispath({ type: 'UpdatePicsInDB', picsInDB: [] })
    // сохранение id для нового (добавляемого) товара
    let newId = await getNewId()
    if(newId) dispath({ type: 'SetNewProd', id: newId, categoryId: categoryId, categoryName: categoryName })
    // getProducts(categoryId)
  }
  // создание новой категории (в массиве)
  function createCat() {
    setCategories([...categories, newCatStore])
    // Очистка полей name, description (для newCat), установка id+1
    dispath({ type: 'ResetupNewCat' })
    // Отключение заморозки действий
    dispath({ type: 'SetFreeze', value: false })
    pushNotify("Категория создана", "notifyGreen")
  }
  // Обновление категории (в массиве)
  function updateCat() {
    // Обновление полей объекта в массиве сategories
    setCategories( categories.map(item => item.id === updCatStore.id ? {...updCatStore} : item) )
    // Отключение заморозки действий
    dispath({ type: 'SetFreeze', value: false })
    pushNotify("Категория сохранена", "notifyGreen")
  }
  // добавление нового товара (в массив)
  function createProd() {
    setProducts([...products, newProdStore])
    // Очистка полей name, description (для newProd), установка id+1
    dispath({ type: 'ResetupNewProd' })
    // Очистка массива файлов. В multiupload.jsx useEffect запустит hideBarAndClean (скрытие прогресс-бара и очистка поля input)
    dispath({ type: 'ClearNewPics' })
    // Отключение заморозки действий
    dispath({ type: 'SetFreeze', value: false })
    pushNotify("Товар добавлен", "notifyGreen")
  }
  // Обновление товара (в массиве)
  function updateProd() {
    // Обновление полей объекта в массиве products
    setProducts( products.map(item => item.id === updProdStore.id ? {...updProdStore} : item) )
    // Очистка массива файлов. В multiupload.jsx useEffect запустит hideBarAndClean (скрытие прогресс-бара и очистка поля input)
    dispath({ type: 'ClearNewPics' })
    // Отключение заморозки действий
    dispath({ type: 'SetFreeze', value: false })
    pushNotify("Товар сохранен", "notifyGreen")
  }
  // Получение данных
  async function getCategories() {
    try {
      setIsCatsLoading(true)
      const response = await axios.get( define.pathToAPI + '/categories/')
      setCategories( response.data.records )
    } catch (e) {
      console.log('Ошибка при получении списка товаров от сервера: ')
      alert('Ошибка при получении списка товаров от сервера\n' + e)
    } finally {
      setIsCatsLoading(false)
    }
  }

  // Получение данных
  async function getProducts(id) {
    setProducts([])
    try {
      setIsProdsLoading(true)
      const response = await axios({
        method: 'get',
        url: define.pathToAPI + '/products/',
        params: {
          categoryId: id,
        },
      })// axios

      if(response.data.records){
        setProducts( response.data.records )        
      }
      
    } catch (e) {
      console.log(e + '\nОшибка при получении списка товаров от сервера')
    } finally {
      setIsProdsLoading(false)
    }
  }

  // Удаление категории (из массива)
  function deleteCategoryData(id) {
    // Если удален товар, "открытый" для редактирования, то устанавливаем action в default
    if(id === updCatStore.id) dispath({ type: 'SetActionDefault' })
    // Удаление объекта (по id) из массива products
    setCategories( categories.filter(value => value.id !== id) )
    // useEffect запустит: определение и сохранение нового id
    pushNotify("Категория удалена", "notifyOrange")
  }

  // Удаление товара (из массива)
  function deleteProductData(id) {
    // Если удален товар, "открытый" для редактирования, то устанавливаем action в default
    if(id === updProdStore.id) dispath({ type: 'SetActionDefault' })
    // Удаление объекта (по id) из массива products
    setProducts( products.filter(value => value.id !== id) )
    // useEffect запустит: определение и сохранение нового id
    pushNotify("Товар удален", "notifyOrange")
  }

  useEffect(() => {
    if(authStatus === 'created' || authStatus === 'approved') getCategories()
    if(authStatus === 'created') pushNotify("Добро пожаловать!<br/>Вам открыт доступ к приложению<br/>на " + tokenLifeTimeInfo, "notifyWelcome", welcNotifyDuration)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus])

  useEffect(() => {
    let userToken = localStorage.getItem('AuthToken')
    // При первом запуске проверяем, разрешен ли доступ
    // (то есть актуален ли токен пользователя)
    checkPermissions(userToken)
    
    // Варианты статуса для примера:
    // Статус 1 - приложение используется другим администратором, типа подождите и попробуйте зайти через 10 минут. 
    // Статус 2 - войдите еще раз, пока

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if(authStatus === 'appLoading'){
    return (
      <div className='flex-centered'>
        {/* <h1>Загрузка приложения...</h1> */}
        <NotifyList2 />
      </div>
    )
  }

  return (
    <>
      {(authStatus === 'created' || authStatus === 'approved') ?
        <div className="container">

        <NotifyList2 />
        {/* <NotifyList
          notifyList={ notifyList }
          delNotify={ delNotify }
          pushNotify={ pushNotify }
        /> */}

        <div className="leftPart w540 mw-300">

          {freeze &&
            <div className="freezeLayer"
              onClick={() => setAwayModal(true)}
            ></div> }

          <h1>Каталог</h1>
          <button className="btn greenBtn-outline mb-10" onClick={selectAddCategory}>Создать категорию</button>

          {
          (!isCatsLoading ?
            <Categories
              isProdsLoading={ isProdsLoading }
              categories={ categories }
              products={ products }
              getProducts={ getProducts }
              selectAddProd={ selectAddProd }
              deleteCatsData={ deleteCategoryData }
              deleteProdsData={ deleteProductData }
              // pushNotify={ pushNotify }
            />        
          : <div>Идет загрузка...</div> )}

        </div>
        <div className="rightPart">
          {(() => {
            switch (action) {
              case 'welcome':
                return <FormWelcome>Добро пожаловать</FormWelcome>
              case 'addC':
                return <CatFormAdd
                    header="Создание категории"
                    create={ createCat }
                    // pushNotify={ pushNotify }
                />
              case 'updC':
                return <CatFormUpdate
                    header="Редактирование категории"
                    update={ updateCat }
                    // pushNotify={ pushNotify }
                />
              case 'addP':
                return <ProdFormAdd
                    header="Добавление товара"
                    create={ createProd }
                    // pushNotify={ pushNotify }
                  />
              case 'updP':
                return <ProdFormUpdate
                    header="Редактирование товара"
                    update={ updateProd }
                    delPics={ delPicsToDelete }
                    // pushNotify={ pushNotify }
                  />
              default:
                return <FormDefault>Отлично!</FormDefault>
            }
          })()}
        </div>
        <Modal
          visible={awayModal}
          modalColors="modalBlue"
          header="Изменения не сохранены"
          pic="info"
          message="Хотите продолжить без сохранения?"
          btn1Text="Да"
          btn2Text="Нет"
          сonfirmed={awayConfirmed}
          hide={()=>setAwayModal(false)}
        />
      </div>
      :
      <div className='fill'>
        <div className='wrapper'>
          <div className='access-card w320'>
            <h1>React CMS</h1>
            {/* SPA</p> */}

            {authStatus === 'await' ?
              <div>C приложением работает другой пользователь.<br/>
                { authMsg }
              </div>
              : <></> }

            <button className="btn startBtn mt-15" onClick={ createToken }>Открыть доступ</button><br/>

            <p className='mb-15'>
            Одностраничное приложение (SPA) на React. Интерфейс взаимодействия - REST API. Backend (c базой данных) размещен на коммерческом хостинге.</p>
            <p className='mb-15'>
            <b>Доступ</b> разграничен <b>по времени</b>.</p>
            {/* Чтобы при знакомстве с приложением, вас не отвлекали действия других пользователей - <b>доступ</b> разграничен <b>по времени</b>.</p> */}
            <p className='mb-15'>
            При нажатии на кнопку будет сгенерирован <b>токен на { tokenLifeTimeInfo }</b>.</p>
            Поддержка: web-design@ukr.net

            <MyCounter/>
          </div>
        </div>
      </div>
      }
    </>
  );
}

export default App;
